
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.088","height":"19.767"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"My_settings","data-name":"My settings","transform":"translate(.913 .899)"}},[_c('g',{attrs:{"id":"Group_8264","data-name":"Group 8264","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('circle',{attrs:{"id":"Ellipse_176","data-name":"Ellipse 176","cx":"4.662","cy":"4.662","r":"4.662","transform":"rotate(-77.025 7.773 1.95)"}}),_c('path',{attrs:{"id":"Path_1306","data-name":"Path 1306","d":"M712.321-113.337s1.159-4.53 9.72-4.53 9.561 4.53 9.561 4.53","transform":"translate(-712.321 131.292)"}})])])])
          )
        }
      }
    